<section class="flex flex-col w-full making-deposit">
  <div class="w-full py-4 block sm:hidden">
    <go-back></go-back>
  </div>
  <div class="text-center pb-8 md:pb-20 header">
    <h1 class="outfit extra-bold pb-6 md:pb-8 heading-large">{{ makingDeposit.title | translate }}</h1>
    <p class="paragraph-medium outfit font-normal">{{ makingDeposit.addFund | translate }}</p>
  </div>
  <div class="w-full flex flex-col justify-between items-start md:flex-row gap-8 pb-20 sm:pb-10">
    <div class="flex w-full justify-evenly lg:self-stretch md:justify-evenly items-center flex-col gap-8 sm:gap-4">
      <p class="paragraph-medium font-normal text-center md:text-justify inline-block outfit">
        {{ makingDeposit.extensiveOption | translate }}
        <span class="font-bold">{{ makingDeposit.reloadingOption | translate }}</span>
        {{ makingDeposit.charge | translate }}
      </p>
      <div class="w-72 h-auto">
        <img [src]="makingDeposit.illustrationMobile" alt="" class="w-full block md:hidden object-cover" />
      </div>
      <p class="paragraph-medium font-normal text-center md:text-justify inline-block outfit">
        <span class="font-bold">{{ makingDeposit.freeExperience | translate }}</span>
        {{ makingDeposit.settlingUp | translate }}
        <a class="font-bold underline" (click)="openLink(makingDeposit.link)">{{
          makingDeposit.directDeposit | translate
        }}</a>
        {{ makingDeposit.yourCard | translate }}
      </p>
      <korviu-button type="button" color="tertiary" (click)="findLocation()" class="w-full">{{
        makingDeposit.findLocation | translate
      }}</korviu-button>
    </div>
    <div class="w-full flex justify-center self-stretch items-center">
      <img [src]="makingDeposit.illustration" alt="" class="w-full hidden md:block object-cover" />
    </div>
  </div>
</section>
